<template>
  <div></div>
</template>

<script>
import {
  getTempLogin,
  GETANYTHING,
  getTempLocation,
} from "@/utils/lib/tempLogin.js"; // 临时登录
import { wxRedirectUrl } from "../../../public/config.json";
import { changeWXString } from "../../utils/lib/searchtoobj";

export default {
  data() {
    return {};
  },
  created() {
    console.log(this.$route.query);

    this.wxregister();
  },
  methods: {
    wxregister() {
      let reqBody = {
        code: this.$route.query.code,
        state: this.$route.query.state,
        tempuserguid: localStorage.getItem("userguid"),
        token: JSON.parse(this.$cookie.get("shareToken")),
      };

      this.$http
        .reqPostWeixinRegLoginByShare(reqBody)
        .then((res) => {
          console.log("微信分享注册=====", res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.bus.$emit("saveTokenHandle", res, 1);
              console.log(
                "sessionStorage.getItem()",
               sessionStorage.getItem("userId")
              );
              this.$router.push("/newFiles");
            }
          }
        })
        .catch((err) => {
          console.log("微信分享注册=====err", err);
        });
    },
  },
};
</script>

<style></style>
